import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/global-error.tsx");
